import { axiosInstance } from '../../api';
const BASE_PATH = '/external_assessment';

//Get All external assessments API Call
export let getExternalAssessmentsCards = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_assigned_external_assessments');
        return value;
    } catch (error) {
        return error
    }
}

//Get All external assessments by group API Call
export let getExternalAssessmentsByGroup = async (step_id, assessment_state) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_assigned_external_assessments_by_group', {
            step_id: step_id,
            external_assessment_state: assessment_state
        });
        return value;
    } catch (error) {
        return error
    }
}


export let getPresignedUrlToViewExternalAssessmentSubmission = async (session_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_presigned_url_to_view_external_assessment_submission', {
            session_id: session_id
        });
        return value;
    } catch (error) {
        return error
    }
}

//Get All external assessments by group API Call
export let submitExternalAssessmentReview = async (session_id, marks, comments_array, overallRating) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/submit_external_assessment_review', {
            session_id: session_id,
            score: marks,
            comments: comments_array,
            overallRating: overallRating,
        });
        return value;
    } catch (error) {
        return error
    }
}